import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { FileRecordNew } from '../types/file-record';

export type DocumentViewState = {
    value: FileRecordNew | undefined;
};

const initialState: DocumentViewState = {
    value: undefined,
};

export const documentViewSlice = createSlice({
    name: 'document-view',
    initialState,
    reducers: {
        setViewingDocument: (state, action: PayloadAction<{ record: FileRecordNew }>) => {
            state.value = action.payload.record;
        },
        clearViewingDocument: (state) => {
            state.value = undefined;
        },
    },
});

export const { setViewingDocument, clearViewingDocument } = documentViewSlice.actions;

export default documentViewSlice.reducer;
